
// => Data
import baseClips from '../content/baseClips.json';
import xpacClips from '../content/xpacClips.json';
import cards from '../content/cards.json';


const getBaseClips = (type = null) => {
    let clips = []
    switch(type) {
        case "babes":
            clips = clips.concat(
                baseClips.babes
            )
            break
        case "cocks":
            clips = clips.concat(
                baseClips.cocks,
                baseClips.shots
            )
            break
        default:
            clips = clips.concat(
                // babes
                baseClips.babes,
                // cocks
                baseClips.cocks,
                baseClips.shots
            )
            break
    }
    return clips
}
export { getBaseClips }

const getXpacClips = (type = null) => {
    let clips = []
    switch(type) {
        case "babes":
            clips = clips.concat(
                // TODO: no xpac babes yet!!
            )
            break
        case "cocks":
            clips = clips.concat(
                xpacClips.bbc_deluxe,
                xpacClips.girl_cock
            )
            break
        default:
            clips = clips.concat(
                // babes
                // TODO: no xpac babes yet!!
                // cocks
                xpacClips.bbc_deluxe,
                xpacClips.girl_cock
            )
            break
    }
    return clips
}
export { getXpacClips }

const getAllCards = (type = null) => {
    let allCards = []
    switch(type) {
        case "babes":
            allCards = allCards.concat(
                // base
                cards.baseBabes,
                // xpac
            )
            break
        case "cocks":
            allCards = allCards.concat(
                // base
                cards.baseCocks,
                cards.baseShots,
                // xpacs
                cards.xpacBbcDeluxe,
                cards.xpacGirlCock,
            )
            break
        default:
            allCards = allCards.concat(
                // babes
                cards.baseBabes,
                // cocks
                cards.baseCocks,
                cards.baseShots,
                cards.xpacBbcDeluxe,
                cards.xpacGirlCock,
            )
            break
    }
    return allCards
}
export { getAllCards }


const findClipById = (id) => {
    // Combine base clips to search through
    let all = getBaseClips()
    // Add xpac clips to search through
    all = all.concat(getXpacClips())

    // Find clip with id we're looking for
    return all.find((c) => c.id === id)
}
export { findClipById }

const findCardByClipId = (id) => {
    // All cards
    let all = getAllCards()

    return all.find(c => c.clip === id)
}
export { findCardByClipId }


const isClipIdUnlocked = (unlocked = [], id) => {
    let card = findCardByClipId(id)
    return unlocked.includes(card.id)
}
export { isClipIdUnlocked }